const eventCategory = "Party_peshi";

export const viewDetailPartyPeshiSessionTime = {
    event: "session_time_bottom_sheet_party_peshi",
    eventAction: "time spent on Party Peshi details page",
    eventCategory
};

export const viewDetailNocSessionTime = {
    event: "session_time_bottom_sheet_noc",
    eventAction: "time spent on NOC details page",
    eventCategory
};
